// extracted by mini-css-extract-plugin
export default {"container":"Tags_container__lIRUM","btnContainer":"Tags_btnContainer__HoFyn","addBtn":"Tags_addBtn__E-kdO"};